import { Redirect, Route } from "react-router-dom";
import React, { useEffect } from "react";
import { useState } from "react";

const AuthRoute = ({ component: Component, ...rest }: { [key: string]: any }) => {
  const [isLogin, setIsLogin] = useState(null) as any;
  useEffect(() => {
    (() => {
      let userLoginInfo = localStorage.getItem("userLoginInfo") as any;

      if (userLoginInfo === null) {
        setIsLogin(false);
        return false;
      }

      try {
        // let hasAccessToken = JSON.parse(userLoginInfo) as any;
        setIsLogin(true);
      } catch (e) {
        setIsLogin(false);
      }
    })();
  }, [isLogin]);
  // console.log("public routes is login? ", isLogin);
  return (
    <>
      {isLogin !== null ? (
        <Route
          {...rest}
          render={(props) =>
            !isLogin ? (
              <Component {...props} />
            ) : (
              <Redirect
                to={{
                  pathname: "/profile",
                }}
              />
            )
          }
        />
      ) : (
        ""
      )}
    </>
  );
};

export default AuthRoute;
